/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LeadTaskWorkflowItemCreationSource = {
    Base: 'BASE',
    Picklist: 'PICKLIST',
    OneOff: 'ONE_OFF',
} as const;
export type LeadTaskWorkflowItemCreationSource = typeof LeadTaskWorkflowItemCreationSource[keyof typeof LeadTaskWorkflowItemCreationSource];


export function instanceOfLeadTaskWorkflowItemCreationSource(value: any): boolean {
    for (const key in LeadTaskWorkflowItemCreationSource) {
        if (Object.prototype.hasOwnProperty.call(LeadTaskWorkflowItemCreationSource, key)) {
            if (LeadTaskWorkflowItemCreationSource[key as keyof typeof LeadTaskWorkflowItemCreationSource] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LeadTaskWorkflowItemCreationSourceFromJSON(json: any): LeadTaskWorkflowItemCreationSource {
    return LeadTaskWorkflowItemCreationSourceFromJSONTyped(json, false);
}

export function LeadTaskWorkflowItemCreationSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadTaskWorkflowItemCreationSource {
    return json as LeadTaskWorkflowItemCreationSource;
}

export function LeadTaskWorkflowItemCreationSourceToJSON(value?: LeadTaskWorkflowItemCreationSource | null): any {
    return value as any;
}

export function LeadTaskWorkflowItemCreationSourceToJSONTyped(value: any, ignoreDiscriminator: boolean): LeadTaskWorkflowItemCreationSource {
    return value as LeadTaskWorkflowItemCreationSource;
}

